/**
 * @file リンクボタン。hrefが指定されればLinkコンポーネント、なければbuttonとして描画する。positionによりレイアウトクラスを切り替える。
 */
import { ReactNode } from 'react';
import Link from 'next/link';

type Props = Partial<{
  position: 'right';
  href: string;
  onClick: (e: React.UIEvent<Element, UIEvent>) => void;
  className: string;
  children: ReactNode;
}>;

const LinkButton = ({ position, children, href, onClick, className }: Props) => {
  return (
    // positionが'right'の場合は右寄せレイアウト用クラスを適用
    <div className={position === 'right' ? 'buttonArea' : 'button-area'}>
      {/* hrefの有無でLink/buttonを切り替え、SPA遷移と通常クリックの両方に対応 */}
      {href ? (
        <Link className={className} href={href}>
          {position === 'right' ? <span>{children}</span> : children}
        </Link>
      ) : (
        <button onClick={onClick} className={className}>
          {position === 'right' ? <span>{children}</span> : children}
        </button>
      )}
    </div>
  );
};

export default LinkButton;
